import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "arrow"]

  connect() {
    // Customer status popover controller connected
    this.isOpen = false
    this.hoverTimeout = null
  }

  // Zeigt Ladesymbol während der Neuberechnung
  showLoadingState() {
    if (this.hasContentTarget) {
      this.contentTarget.innerHTML = `
        <div class="flex items-center justify-center p-4">
          <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
          <span class="ml-2 text-sm text-gray-600">Status wird neu berechnet...</span>
        </div>
      `
    }
  }

  // Öffnet das Popover (Mouseover) - nur wenn genug Platz ist
  show() {
    if (this.hasEnoughSpaceForSidebar()) {
      // Clear any existing timeout
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout)
      }
      
      if (this.hasContentTarget) {
        this.showGlobalPopover()
      }
    }
  }

  // Schließt das Popover (Mouseleave)
  hide() {
    // Verzögerung beim Verlassen, falls Benutzer zur Sidebar navigiert
    this.hoverTimeout = setTimeout(() => {
      if (!this.isOpen) {
        this.hideGlobalPopover()
      }
    }, 300) // 300ms Verzögerung
  }

  // Toggle das Popover (Klick) - immer möglich
  toggle() {
    if (this.isOpen) {
      this.hideGlobalPopover()
      this.isOpen = false
    } else {
      this.showGlobalPopover()
      this.isOpen = true
    }
  }

  // Prüft ob genug Platz für die Sidebar ist
  hasEnoughSpaceForSidebar() {
    const triggerRect = this.element.getBoundingClientRect()
    const viewportWidth = window.innerWidth
    const sidebarWidth = 384 // w-96 = 384px
    
    // Prüfe ob genug Platz rechts für die Sidebar ist
    const spaceRight = viewportWidth - triggerRect.right
    return spaceRight >= sidebarWidth + 20 // 20px Puffer
  }

  // Zeigt den globalen Popover
  showGlobalPopover() {
    const globalPopover = document.querySelector('[data-controller*="global-popover"]')
    if (globalPopover) {
      const content = this.contentTarget.innerHTML
      globalPopover.dispatchEvent(new CustomEvent('global-popover:show', { 
        detail: { content: content } 
      }))
      this.isOpen = true
    }
  }

  // Versteckt den globalen Popover
  hideGlobalPopover() {
    const globalPopover = document.querySelector('[data-controller*="global-popover"]')
    if (globalPopover) {
      globalPopover.dispatchEvent(new CustomEvent('global-popover:hide'))
      this.isOpen = false
    }
  }

  // Schließt das Popover (wird vom X-Button aufgerufen)
  close() {
    this.hideGlobalPopover()
    this.isOpen = false
  }

  // Bereinigt beim Entfernen des Controllers
  disconnect() {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout)
    }
  }
}
